<div class="modal-content">
  <div id="paperReport">
    <div class="modal-header">
      <h1 class="modal-title">
        Add Paper Report
      </h1>
    </div>
    <form [formGroup]="reportForm" (ngSubmit)="readyToSubmit ? onSubmit() : onReview()">
      <div class="modal-body">
        <ng-container *ngIf="!readyToSubmit; else paper_report_review">

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <app-autocomplete-input *ngIf="!dealer; else text_input" formControlName="dealer"
                                    (keydown)="moveToNextOnEnter($event, 'reportType')"
                                    (itemSelect)="onDealerSelect($event)"
                                    (focusOut)="onDealerEnter($event)" [id]="'dealerId'"
                                    [title]="'Dealer ID'" [editable]="false" [aria-label]="'dealer'"
                                    [aria-label]="'dealer id'"
                                    [autocomplete]="dealerAutocomplete"
                                    [inputFormatter]="dealerAutocompleteInputFormatter"
                                    [resultFormatter]="dealerAutocompleteFormatter"
                                    [isInvalid]="formErrorHandler.hasError(reportForm ,'dealer')">
                </app-autocomplete-input>

                <ng-template #text_input>
                  <label for="dealerId">Dealer ID</label>
                  <input (keydown)="moveToNextOnEnter($event, 'reportType')" type="text" id="dealerId" formControlName="dealer" class="form-control required" aria-required="true" readonly="readonly"
                         aria-label="dealer"
                         [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'dealer')}">

                </ng-template>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'dealer', 'required')" role="alert"
                     class="formError text-danger"
                     aria-live="assertive">
                  Please, select correct Dealer ID.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dealerName">Dealer Name</label>
                <input type="text" id="dealerName" formControlName="dealerName" class="form-control" readonly="readonly"
                       aria-label="dealer name" tabindex="-1"
                       [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'dealerName', 'required')}">
                <div *ngIf="formErrorHandler.hasError(reportForm ,'dealerName', 'required')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, enter the Dealer Name.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="reportType">Report Type</label>
                <select (keydown)="moveToNextOnEnter($event, 'year')" class="form-control required" aria-required="true" id="reportType" formControlName="reportType"
                        aria-label="report type"
                        [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'reportType', 'required')}"
                        (change)="onReportTypeChange($event)">
                  <option [disabled]="true" value="">-- Select a Report Type --</option>
                  <option *ngIf="marketTypes.has(MarketType.NAQ)" [ngValue]="ReportType.P">Purchase</option>
                  <option *ngIf="marketTypes.has(MarketType.AQ)" [ngValue]="ReportType.PAQ">Purchase-AQ</option>
                </select>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'reportType', 'required')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, select the report type.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="year">Year</label>
                <input (keydown)="moveToNextOnEnter($event, 'month')" type="text" id="year" formControlName="year" mask='9*' class="form-control required" aria-required="true"
                       aria-label="day"
                       [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm, 'year')}">

                <div *ngIf="formErrorHandler.hasError(reportForm ,'year')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, select valid Year of the report.
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="month">Month</label>
                <select (keydown)="moveToNextOnEnter($event, 'dateReceived')" class="form-control required" aria-required="true" id="month" formControlName="month" aria-label="month"
                        [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm, 'month')}" required>
                  <option [ngValue]="''">-- Select month --</option>
                  <option [ngValue]="Months.JANUARY">{{Months.meaning(Months.JANUARY)}}</option>
                  <option [ngValue]="Months.FEBRUARY">{{Months.meaning(Months.FEBRUARY)}}</option>
                  <option [ngValue]="Months.MARCH">{{Months.meaning(Months.MARCH)}}</option>
                  <option [ngValue]="Months.APRIL">{{Months.meaning(Months.APRIL)}}</option>
                  <option [ngValue]="Months.MAY">{{Months.meaning(Months.MAY)}}</option>
                  <option [ngValue]="Months.JUNE">{{Months.meaning(Months.JUNE)}}</option>
                  <option [ngValue]="Months.JULY">{{Months.meaning(Months.JULY)}}</option>
                  <option [ngValue]="Months.AUGUST">{{Months.meaning(Months.AUGUST)}}</option>
                  <option [ngValue]="Months.SEPTEMBER">{{Months.meaning(Months.SEPTEMBER)}}</option>
                  <option [ngValue]="Months.OCTOBER">{{Months.meaning(Months.OCTOBER)}}</option>
                  <option [ngValue]="Months.NOVEMBER">{{Months.meaning(Months.NOVEMBER)}}</option>
                  <option [ngValue]="Months.DECEMBER">{{Months.meaning(Months.DECEMBER)}}</option>
                </select>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'month')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, select valid Month of the report.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dateReceived">Date Received</label>

                <div class="input-group">
                  <input (keydown)="moveToNextOnEnter($event,  'elem-0-day')"  type="text" id="dateReceived" formControlName="dateReceived" placeholder="mm/dd/yyyy"
                         class="form-control required" aria-required="true"
                         [ngClass]="{'is-invalid': formErrorHandler.hasError(reportForm ,'dateReceived')}"
                         [dropSpecialCharacters]="false" mask="00/00/0000"
                         required>
                  <!--<div class="input-group-append" (click)="d.toggle()" role="button">-->
                    <!--<span class="input-group-text"><i class="fas fa-calendar"></i></span>-->
                  <!--</div>-->
                </div>
                <div *ngIf="formErrorHandler.hasError(reportForm ,'dateReceived')" role="alert"
                     class="formError text-danger" aria-live="assertive">
                  Please, enter valid report date.
                </div>

              </div>
            </div>
          </div>

          <div class="row" [ngClass]="{'disabled-input': !reportForm.get('dealer').value || !reportForm.get('reportType').value}">
            <div class="col-md-12">
              <table class="paperFormTable">
                <thead>
                <tr>
                  <th style="width: 4%">Day</th>
                  <th style="width: 10%">License</th>
                  <th style="width: 15%">Species</th>
                  <th *ngIf="reportForm.controls['reportType'].value == ReportType.P" style="width: 7%">Lbs.</th>
                  <th *ngIf="reportForm.controls['reportType'].value" style="width: 7%">Pcs.</th>
                  <th style="width: 12%">Value</th>
                  <th *ngIf="reportForm.controls['reportType'].value == ReportType.P" style="width: 6%">Condition</th>
                  <th style="width: 8%">Vessel ID</th>
                  <th style="width: 6%">Comments</th>
                  <th style="width: 5%">Status</th>
                  <th style="width: 2%"></th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let quickReport of reportForm.get('quickReports').controls; let i = index">
                  <tr formArrayName="quickReports" class="form-group-sm">
                    <ng-container [formGroupName]="i">
                      <td>
                        <input (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-seller')" type="text" formControlName="day" mask='9*' class="form-control form-control-sm required" aria-required="true"
                               aria-label="day" [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'day')}"
                               [id]="'elem-' + i + '-day'">
                      </td>
                      <td>
                        <app-autocomplete-input (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-species')"
                                            formControlName="seller"
                                            (itemSelect)="onSellerSelect($event, i)"
                                            (focusOut)="onSellerEnter($event, i)"
                                            [editable]="false" [aria-label]="'commercial marine licence number'"
                                            [aria-label]="'commercial marine licence number'"
                                            [autocomplete]="licenseAutocomplete"
                                            [inputFormatter]="licenseAutocompleteFormatter"
                                            [resultFormatter]="licenseAutocompleteFormatter"
                                            [isInvalid]="formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'seller')"
                                            [id]="'elem-' + i + '-seller'"
                                            [debounceTime]="50">
                        </app-autocomplete-input>
                      </td>
                      <td>
                        <app-autocomplete-input (keydown)="moveToNextOnEnter($event, 'elem-' + i + (isLbsBased(i) ? '-lbsBought' : '-piecesBought'))"
                                            formControlName="species"
                                            (itemSelect)="onSpeciesSelect($event, i)"
                                            (focusOut)="onSpeciesFocusOut($event, i)"
                                            [editable]="false" [aria-label]="'species'"
                                            [aria-label]="'species'"
                                            [autocomplete]="speciesAutocomplete"
                                            [inputFormatter]="speciesAutocompleteFormatter"
                                            [resultFormatter]="speciesAutocompleteFormatter"
                                            [isInvalid]="formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'species')"
                                            [id]="'elem-' + i + '-species'"
                                            [debounceTime]="50">
                        </app-autocomplete-input>
                      </td>
                      <td *ngIf="reportForm.controls['reportType'].value == ReportType.P">
                        <input type="text" id="purchase-{{i}}-lbs-bought" formControlName="lbsBought" mask="0*.00" [dropSpecialCharacters]="false"
                               class="form-control"
                               [attr.aria-required]="isLbsBased(i)"
                               aria-label="quantity pounds bought"
                               (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-piecesBought')"
                               (keyup)="onPurchaseUpdate()"
                               [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'lbsBought'), 'required': isLbsBased(i)}"
                               [attr.disabled]="isPcsBased(i) ? 'disabled' : null" [id]="'elem-' + i + '-lbsBought'">
                      </td>
                      <td *ngIf="reportForm.controls['reportType'].value">
                        <input type="text" id="purchase-{{i}}-pieces-bought" formControlName="piecesBought" mask='9*'
                               class="form-control"
                               [attr.aria-required]="isPcsBased(i) || (quickReport.get('species').value && !quickReport.get('species').value.pieceExempt)" aria-label="quantity pieces bought"
                               (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-value')"
                               (keyup)="onPurchaseUpdate()"
                               [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'piecesBought'), 'required': isPcsBased(i) || (quickReport.get('species').value && !quickReport.get('species').value.pieceExempt)}"
                               [id]="'elem-' + i + '-piecesBought'">
                      </td>
                      <td *ngIf="reportForm.controls['reportType'].value">
                        <input type="text" formControlName="value"
                               appCurrencyInputMask
                               class="form-control required"
                               aria-label="value"
                               aria-required="true"
                               (keydown)="moveToNextOnEnter($event, reportForm.controls['reportType'].value == ReportType.P ? 'elem-' + i + '-condition' : 'elem-' + i + '-vessel')"
                               (keyup)="onPurchaseUpdate()"
                               [id]="'elem-' + i + '-value'"
                               [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'value')}"
                               [required]="true">

                      </td>
                      <td *ngIf="reportForm.controls['reportType'].value == ReportType.P">
                        <app-autocomplete-input (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-vessel')" formControlName="condition"
                                            (itemSelect)="onConditionSelect($event, i)"
                                            (focusOut)="onConditionFocusOut($event, i)"
                                            [editable]="false" [aria-label]="'condition'"
                                            [autocomplete]="conditionAutocomplete"
                                            [inputFormatter]="conditionAutocompleteFormatter"
                                            [resultFormatter]="conditionAutocompleteFormatter"
                                            [isInvalid]="formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'condition')"
                                            [id]="'elem-' + i + '-condition'"
                                            [debounceTime]="50">
                        </app-autocomplete-input>
                      </td>
                      <td>
                        <app-autocomplete-input formControlName="vesselId"
                                            (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-comments')"
                                            [ngClass]="{'disabled-input': !quickReport.get('seller').value}"
                                            (itemSelect)="onVesselSelect($event, i)"
                                            (focusOut)="onVesselEnter($event, i)"
                                            [editable]="true" [aria-label]="'vessel'"
                                            [autocomplete]="vesselAutocomplete"
                                            [index]="i"
                                            [inputFormatter]="vesselAutocompleteFormatter"
                                            [resultFormatter]="vesselAutocompleteFormatter"
                                            [isInvalid]="formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'vesselId')"
                                            [id]="'elem-' + i + '-vessel'"
                                            [debounceTime]="50">
                        </app-autocomplete-input>
                      </td>
                      <td>
                        <input (keydown)="moveToNextOnEnter($event, 'elem-' + i + '-status')" type="text" formControlName="comments"
                               class="form-control" aria-label="comments"
                               [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i, 'comments')}"
                               [id]="'elem-' + i + '-comments'">
                      </td>
                    <td>
                      <select (keydown)="moveToNextOnEnter($event, 'elem-' + (i + 1) + '-day')" class="form-control" formControlName="status" aria-label="status"
                              [ngClass]="{'is-invalid': formErrorHandler.hasArrayError(reportForm, 'quickReports', i ,'status')}"
                              [id]="'elem-' + i + '-status'">
                        <option selected="selected"></option>
                        <option [ngValue]="ApprovalStatus.APPROVED">{{ApprovalStatus.meaning(ApprovalStatus.APPROVED)}}</option>
                        <option [ngValue]="ApprovalStatus.PENDING">{{ApprovalStatus.meaning(ApprovalStatus.PENDING)}}</option>
                        <option [ngValue]="ApprovalStatus.NO_RESPONSE">{{ApprovalStatus.meaning(ApprovalStatus.NO_RESPONSE)}}</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <i (click)="removeQuickReport(i)" class="fas fa-trash deleteIcon"> </i>
                    </td>
                    </ng-container>
                  </tr>
                  <tr *ngIf="showDeleteRecordWarning == i" class="alert alert-danger">
                    <td colspan="11">
                      <div>
                        <span>
                          Are you sure you want to delete this record? To confirm, click delete icon again.
                        </span>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                </table>
                <br>
                <table>
                  <tbody>
                  <tr>
                    <td style="width: 20%">
                      <button type="button" class="btn btn-primary btn-sm" (click)="addQuickReports(10,true)">
                        <i class="fas fa-plus"> </i> Add 10 Rows
                      </button>
                    </td>
                    <td style="width: 15%; text-align: right"><strong>Totals: </strong></td>
                    <td style="width: 5%"><input type="text" aria-label="Units total" disabled="true" class="form-control form-control-sm" [value]="totalCount"></td>
                    <td style="width: 20%"><input type="text" aria-label="Price total" disabled="true" class="form-control form-control-sm" [value]="totalPrice | bigCurrency"></td>
                    <td style="width: 40%">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="showCancelWarning" class="modal-body">
        <div class="row">
          <div class="col-md-12">

            <div class="alert alert-danger">
                  <span>Are you sure you want to close the screen without saving or submitting the input? To confirm, click
                    cancel again.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <div>
              <button *ngIf="readyToSubmit && !loading" class="btn btn-primary btn mr-1" (click)="onBack()">
                <i class="fas fa-edit"> </i> Back
              </button>

              <button *ngIf="!readyToSubmit && !loading" class="btn btn-primary btn mr-1" type="submit" [disabled]="isEmpty() || !isValid()">
                <i class="fas fa-check"> </i> Review
              </button>

              <button *ngIf="readyToSubmit && !loading" class="btn btn-primary btn mr-1" type="submit">
                <i class="fas fa-check"> </i> Submit
              </button>

              <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>

              <button class="btn btn-secondary btn" type="button" (click)="onCancel()">
                <i class="fas fa-times"> </i>&nbsp;Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #paper_report_review>
  <div class="row">
    <div class="col-md-3">
      <dl>
        <dt>Dealer ID</dt>
        <dd class="ng-binding">{{paperReport.dealerId}}</dd>
      </dl>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>Dealer Name</dt>
        <dd class="ng-binding">{{paperReport.dealerName}}</dd>
      </dl>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>Report Type</dt>
        <dd class="ng-binding">
          <ng-container [ngSwitch]="paperReport.reportType">
            <span *ngSwitchCase="ReportType.P">Purchase</span>
            <span *ngSwitchCase="ReportType.PAQ">Purchase-AQ</span>
          </ng-container>
        </dd>
      </dl>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
      <dl>
        <dt>Year</dt>
        <dd class="ng-binding">{{paperReport.year}}</dd>
      </dl>
    </div>
    <div class="col-md-3">
      <dl>
        <dt>Month</dt>
        <dd class="ng-binding">{{Months.meaning(paperReport.month)}}</dd>
      </dl>
    </div>
    <div class="col-md-3">
      <dl>
        <dt>Date Received</dt>
        <dd class="ng-binding">{{paperReport.dateReceived}}</dd>
      </dl>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Day</th>
          <th>License</th>
          <th>Name</th>
          <th>Species</th>
          <th *ngIf="paperReport.reportType == ReportType.P">Lbs.</th>
          <th>Pcs.</th>
          <th>Value</th>
          <th *ngIf="paperReport.reportType == ReportType.P">Condition</th>
          <th>Vessel ID</th>
          <th>Comments</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let quickReport of paperReport.paperPurchaseReportItems; let i = index">
          <td>{{quickReport.day}}</td>
          <td>{{quickReport.sellerId}}</td>
          <td>{{quickReport.sellerName}}</td>
          <td>
            <ng-container [ngSwitch]="paperReport.reportType">
              <span *ngSwitchCase="ReportType.P">{{quickReport.purchase.foodSpecies.name}}
                {{quickReport.purchase.foodSpecies.localNames ? '(' + quickReport.purchase.foodSpecies.localNames + ')' : ''}}</span>
              <span *ngSwitchCase="ReportType.PAQ">{{quickReport.purchase.aqSpecies.name}}
                {{quickReport.purchase.aqSpecies.localNames ? '(' + quickReport.purchase.aqSpecies.localNames + ')' : ''}}</span>
            </ng-container>
          </td>
          <td *ngIf="paperReport.reportType == ReportType.P">{{quickReport.purchase.lbsBought}}</td>
          <td>{{quickReport.purchase.piecesBought}}</td>
          <td>{{quickReport.purchase.value}}</td>
          <td *ngIf="paperReport.reportType == ReportType.P">{{quickReport.purchase.condition ? quickReport.purchase.condition.description : ''}}</td>
          <td>{{quickReport.vessel ? quickReport.vessel.id: ''}}</td>
          <td style="max-width: 200px;"><div class="remarks">{{quickReport.remarks}}</div></td>
          <td>
            {{ApprovalStatus.meaning(ApprovalStatus[quickReport.status])}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
